// extracted by mini-css-extract-plugin
module.exports = {"EventDashboard":"EventDashboard_EventDashboard__EmXTS"};